import { Box, styled } from '@mui/material';
import { Title } from '@components';
import { ReactNode } from 'react';
import { BoxProps } from '@mui/system';
import classnames from 'classnames';
import { breakpoints } from '@themes/theme.helpers';

// STYLES
//--------

const ContentBoxWrapper = styled(Box)`
  background-color: white;
  padding: 16px;
  border-radius: 4px;

  ${breakpoints.up('md')} {
    padding: 40px;
  }

  .main-title {
    padding-bottom: 20px;
  }

  .content-box-row {
    flex-direction: column;
    ${breakpoints.up('md')} {
      flex-direction: row;
    }
  }
`;

const ContentBoxInner = styled(Box)`
  display: flex;
  flex-direction: column;
  &.stretch > .content-box-row {
    justify-content: space-between;
  }

  .content-box-label {
    ${breakpoints.up('md')} {
      width: 200px;
    }
  }
`;

const Row = styled(Box)`
  display: flex;
  padding: 5px 0;
  &.total {
    font-weight: 700;
    font-size: 24px;
    padding: 20px 0;
  }
`;

const Label = styled(Box)``;
const Value = styled(Box)`
  font-weight: 700;

  &.regular {
    font-weight: 400;
  }
`;

export type ContentBoxProps = BoxProps & {
  title?: string;
  children?: ReactNode;
  stretch?: boolean;
};

export const ContentBox = ({
  title,
  children,
  stretch,
  className,
  ...boxProps
}: ContentBoxProps) => {
  const mainClassName = classnames(className, { stretch: stretch });
  return (
    <ContentBoxWrapper {...boxProps} className={mainClassName}>
      <Title variant='h3'>{title}</Title>
      <ContentBoxInner>{children}</ContentBoxInner>
    </ContentBoxWrapper>
  );
};

export type ContentBoxItemProps = BoxProps & {
  label?: string;
  children?: ReactNode;
};

export const ContentBoxItem = ({ label, children, ...boxProps }: ContentBoxItemProps) => {
  if (!children) {
    return null;
  }
  return (
    <Row {...boxProps} className='content-box-row'>
      {label && <Label className='content-box-label'>{label}</Label>}
      {children && <Value className='content-box-value'>{children}</Value>}
    </Row>
  );
};
